import tw from 'twin.macro';
import {
  styled
} from 'styled-components';

export const GroupText = styled.div`
  ${tw`text-17-26 font-bold mb-4 text-gray7`}
`;
